import { FC } from 'react';

import { EmptyLayoutProps } from './EmptyLayout.types';

export const EmptyLayout: FC<EmptyLayoutProps> = ({ children }) => {
    return <>{children}</>;
};
